export default __webpack_public_path__ + "static/MNSMWHITELIGHTNIN_CIRCLETEE_600x600-04966d5656331788a5b670804151a54a.png";